export default function(){
    if (process.env.MIX_MAX_UPLOAD_FILESIZE_MB) {
        return parseInt(process.env.MIX_MAX_UPLOAD_FILESIZE_MB) * 1024 * 1024;
    }
    return 2 * 1024 * 1024;
}
